import script from "./ActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionButton.vue?vue&type=script&setup=true&lang=js"

import "./ActionButton.vue?vue&type=style&index=0&id=05ec3342&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ec3342"]])

export default __exports__